import React, { Fragment } from "react";
import { Label, Row, Col, Container } from "reactstrap";
import { FormField, CheckFormField } from "../../../../../../utils";

import style from "./OrderTable.module.scss";

export const OrderTable = ({ group, loading, handleChange, i, eventErrors }) => {
  return (
    <Fragment>
      <Row>
        <Col xs="4" sm="4" md="4">
          Order - Group
        </Col>
        <Col xs="8" sm="8" md="8">
          <table className={style.table}>
            <thead className={style.thead}>
              <th>
                <Label className={style.label}>Name</Label>
              </th>
              <th>
                <Label className={style.label}>Value</Label>
              </th>
              <th>
                <Label className={style.label}>Adds</Label>
              </th>
              <th>
                <Label className={style.label}>Volume</Label>
              </th>
            </thead>
            <tbody>
              {group.map((groupItem, index) => {
                return (
                  <tr key={index} className={style.tr}>
                    <td>
                      <p>{groupItem.AssetGroupName ? groupItem.AssetGroupName : "-"}</p>
                    </td>
                    <td>
                      <p>{groupItem.AssetGroupValue ? groupItem.AssetGroupValue : "-"}</p>
                    </td>
                    <td style={{ padding: "0.75rem", verticalAlign: "top" }}>
                      <CheckFormField
                        initialValue={groupItem.GroupAdds}
                        disabled={true}
                        value={groupItem.GroupAdds}
                        name={"adds"}
                      />
                    </td>
                    <td>
                      <FormField
                        disabled={loading}
                        value={groupItem.GroupVolume}
                        name="groupVolume"
                        type="number"
                        description={
                          groupItem.CommissionGroupMax.trim() === "0.00000000"
                            ? "Must be higher than 0%"
                            : `Must be between ${parseFloat(groupItem.CommissionGroupMin)}% and ${parseFloat(
                                groupItem.CommissionGroupMax
                              )}%`
                        }
                        error={eventErrors["groupVolume"]}
                        onChange={(name, value) => handleChange(name, i, "event", value)}
                        dataTypeDecimalName="currency"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Col>
      </Row>
    </Fragment>
  );
};
